module.exports = require("./de-DE.js");